import React from 'react';
import './DataUnavailable.css';

interface NoDataPropsType {
  description: string;
}

const DataUnavailable: React.FC<NoDataPropsType> = ({ description }) => {
  return <div className="empty-state-message"> {description} </div>;
};

export default DataUnavailable;
